import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";
import { Spinner } from "@twilio-paste/core/spinner";

import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import type { Message } from "@twilio/conversations";
import type { AnyAction } from "redux";
import type { ThunkDispatch } from "redux-thunk";
import type { ChatReducer } from "../store/chat.reducer";
import type { SessionReducer } from "../store/session.reducer";

import { sendConversationMessage, setShowMessageInput } from "../store/actions/genericActions";
interface ReplyAction {
    title: string;
    id: string;
}
interface MessageContentData {
    replies?: ReplyAction[];
}
export const MessageActions = ({ message, isLast = true }: { message: Message, isLast?: boolean }) => {

    const [actions, setActions] = useState<MessageContentData | null>(null);
    const [replied, setReplied] = useState<boolean>(!isLast);
    const [loading, setLoading] = useState<boolean>(true);

    const dispatch = useDispatch<ThunkDispatch<ChatReducer | SessionReducer, unknown, AnyAction>>();


    useEffect(() => {
        const fetchContentData = async () => {
            const data = await message.getContentData();
            setActions(data as MessageContentData);
            setLoading(false);
        }

        fetchContentData();
    }, [message]);


    const handleReplyClick = useCallback(async (reply: string) => {
        dispatch(sendConversationMessage({
            body: reply,
            conversation: message.conversation
        }));
        setReplied(true);
        dispatch(setShowMessageInput(true));
    }, [message.conversation]);

    const replies = actions?.replies;

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" padding="space30" marginTop="space40" marginBottom="space40">
                <Spinner
                    title="Loading replies..."
                    decorative={false}
                    size="sizeIcon100"
                    color="colorTextPrimaryStrong"
                />
            </Box>
        );
    };

    return (
        <Box display="flex" flexDirection="column" marginTop="space20">
            {replies && Array.isArray(replies) ? (
                replies.map((action, index: number) => (
                    <Box key={index} marginTop="space30">
                        <Button
                            variant="secondary"
                            onClick={() => handleReplyClick(action.title)}
                            disabled={replied}
                            fullWidth={true}

                        >
                            {action.title}
                        </Button>
                    </Box>
                ))
            ) : null}
        </Box>
    );
};
